/**
 * 关于。
 * 放在三个通道之后：先让人看见做了什么，再解释为什么是阳仔AI做三样。
 * 版式沿用 datasheet 的骨架，不引入新的视觉花样。
 */
export default function AboutSection() {
  return (
    <section
      id="about"
      className="border-t border-rack-bone/[0.08] bg-rack-ground py-20 sm:py-28"
      aria-labelledby="about-title"
    >
      <div className="mx-auto max-w-[1180px] px-6 sm:px-10">
        <div className="flex flex-wrap items-baseline gap-x-5 gap-y-2">
          <span className="font-readout text-[11px] tracking-[0.22em] text-rack-bone/30">ABOUT</span>
          <h2
            id="about-title"
            className="font-songti text-[clamp(1.5rem,4vw,2.15rem)] font-semibold tracking-[0.14em] text-rack-bone"
          >
            关于
          </h2>
        </div>

        <div className="mt-11 grid gap-x-12 gap-y-10 lg:grid-cols-[1fr_320px]">
          <div>
            <p className="max-w-[36ch] font-songti text-[clamp(1.15rem,2.9vw,1.6rem)] font-semibold leading-[1.5] tracking-[0.08em] text-rack-bone/92">
              三个方向不是三个爱好
            </p>
            <div className="mt-6 max-w-[64ch] space-y-5 text-[13.5px] leading-[1.95] text-rack-bone/50">
              <p>
                十年大厂技术人，现在阳仔AI做产品。动捕、智能体、量化看着离得很远，底下是同一件事：
                把一段连续的、含噪的、没人标注过的现实信号，变成机器能判定、能执行、能复盘的东西。
              </p>
              <p>
                摄像头里的动作、模型的一次运行、市场的一段行情，区别只在数据从哪来。
                解算、判定、留痕、自动执行这四步是共用的——所以阳仔AI能同时开三条线，
                而不是把精力摊薄成三份。
              </p>
              <p>
                做法上偏执两件事：<span className="text-rack-bone/80">端上能跑的就不上云</span>，
                <span className="text-rack-bone/80">能自动跑完的就不留人工步骤</span>。
                前者省成本也保隐私，后者决定阳仔AI能不能扛住三条线。
              </p>
            </div>
          </div>

          <div className="self-start">
            {/* 铭牌：头像 + 名字 + 位置。阳仔AI接活，客户第一件想确认的事是「对面是谁、
                在哪儿」——所以头像在这里是信息，不是装饰 */}
            <div className="flex items-center gap-3.5 border-b border-rack-bone/10 pb-5">
              <img
                src="/brand/avatar-256.webp"
                alt="阳仔AI"
                width={56}
                height={56}
                loading="lazy"
                className="h-14 w-14 rounded-[4px] border border-rack-bone/15 object-cover"
              />
              <div>
                <p className="text-[14px] font-medium tracking-[0.02em] text-rack-bone/90">阳仔AI</p>
                <p className="mt-1 font-readout text-[9.5px] uppercase tracking-[0.16em] text-rack-bone/28">
                  SOLO BUILDER · 成都
                </p>
              </div>
            </div>

            <dl className="border-t border-rack-bone/[0.07]">
              {[
                ['角色', '独立开发者'],
                ['背景', '十年大厂技术'],
                ['方向', '动捕 / 智能体 / 量化'],
                ['合作', 'YangZaiAITech'],
                ['站点', 'minddock.ai'],
              ].map(([k, v]) => (
                <div
                  key={k}
                  className="flex items-baseline justify-between gap-3 border-b border-rack-bone/[0.07] py-2.5"
                >
                  <dt className="font-readout text-[9.5px] uppercase tracking-[0.16em] text-rack-bone/28">
                    {k}
                  </dt>
                  <dd className="text-right text-[12px] text-rack-bone/72">{v}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
